export default __webpack_public_path__ + "c8f597991aa1ea9e1b630c2c69ba4987.png";